// extracted by mini-css-extract-plugin
module.exports = {"box":"Page4_box__1gZcu","title":"Page4_title__5Nw6a","boxContent":"Page4_boxContent__1A0-k","labelText":"Page4_labelText__21QLQ"};